<template>
    <div class="bg-a-egg-f5ebdc">
        <CookieBanner class="fixed z-index-fixed w-full"></CookieBanner>
        <TopBar @clickBack="clickBack()"
            :class="[cookieClass]"
            :headerName="headerName"
            :isShowPCI="isShowPCI"></TopBar>
        
        <div class="topbar-index fixed top-0 w-full bg-a-egg-f5ebdc" :class="[cookieClass]">
            <DesktopTopbar :isShowDelivery="isShowDelivery"></DesktopTopbar>
        </div>
        <ProfileBar></ProfileBar>
        <div class="container mx-auto page bg-a-egg-f5ebdc"
            :class="[customClass, cookiePageClass]">
            <div v-if="showTopTitle" class="hidden lg:block font-bold text-24 text-a-brown-502314 text-center py-8">
                {{headerName}}
                <img v-if="isShowPCI" class="inline-block h-6 ml-1" src="@/assets/icon/ic-pci@2x.png" />
            </div>
            <slot></slot>
        </div>
        <div class="hidden lg:block">
            <MainFooter></MainFooter>
        </div>

    </div>
</template>
<script>
//component
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import DesktopTopbar from "@/components/Layout/TopBar/UltimateTopBar/component/DesktopTopbar.vue";
import MainFooter from "../Footer/MainFooter.vue";
import ProfileBar from '../SideMenu/ProfileBar.vue';
import CookieBanner from '../TopBar/UltimateTopBar/component/CookieBanner.vue'
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import CookieMixin from '../../../mixin/CookieMixin.js';


export default {
    name: 'MainPage',
    mixins: [LocaleMixin, CookieMixin],
    components: {
        TopBar,
        DesktopTopbar,
        MainFooter,
        ProfileBar,
        CookieBanner,
    },
    props: {
        customClass: { type: String, default: null },
        showTopTitle: { type: Boolean, default: true },
    },
    data: function() {
        return {
            pageActive: this.$route.name,
            isShowPCI: false,
            isShowDelivery: true,
            headerName: ""
        };
    },
    computed: {
        btnClass: function() {
            if (this.customClass != null) {
                return this.customClass;
            }
            return '';
        },
        cookiePageClass: function () {

            if (this.isShowBannerCookie) {
                return 'accept-cookie-page'
            }
            return '';
        }
    },
    created: function() {
        this.getHeaderName();
    },
    methods: {
        clickBack: function() {
            this.$emit("clickBack");
        },
        getHeaderName: function() {
            switch(this.pageActive) {
                case "OrderSummary":
                    this.headerName = this.lbl.shoppingcart.title;
                    break;
                case "OrderPayment":
                    this.headerName = this.lbl.shoppingcart.title_payment;
                    break;
                case "SubscriptPayment":
                    this.headerName = this.lbl.subscription.subscription_summary.title;
                    break;
                case "DeliveryMethod":
                    this.headerName = this.lbl.deliverymethod.title;
                    this.isShowDelivery = false;
                    break;
                case "DeliveryAddress":
                    this.headerName = this.lbl.shipping.headline_Add;
                    this.isShowDelivery = false;
                    break;
                case "SelectAddress":
                    this.headerName = this.lbl.shipping.headline_select;
                    this.isShowDelivery = false;
                    break;
                case "EditAddress":
                    this.headerName = this.lbl.shipping.headline_edit;
                    this.isShowDelivery = false;
                    break;
                case "AddAddress":
                    this.headerName = this.lbl.shipping.headline_add;
                    this.isShowDelivery = false;
                    break;
                case "Location":
                    this.headerName = this.lbl.shipping.headline_choose_location;
                    break;
                case "AddTaxAddress":
                    this.headerName = this.lbl.tax.headline_add;
                    break;
                case "EditTaxAddress":
                    this.headerName = this.lbl.tax.headline_edit;
                    break;
                case "Coupon":
                    this.headerName = this.lbl.coupon.title;
                    break;
                case "SelectBranch":
                    this.headerName = this.lbl.deliverymethod.select_title;
                    break;
                case "AddCreditCard":
                    this.headerName = this.lbl.creditCard.add_new_title;
                    this.isShowPCI = true;
                    break;
                case "ContactUs":
                    this.headerName = this.lbl.contact.title;
                    break;
                case "terms":
                    this.headerName = this.lbl.pdpa.terms_title;
                    break;
                case "privacy":
                    this.headerName = this.lbl.pdpa.privacy_title;
                    break;
                case "TierLevel":
                    this.headerName = this.lbl.tierlevel.title;
                    break;
                case "CreditDebitCard":
                    this.headerName = this.lbl.creditCard.credit_debit_title;
                    break;
                case "TaxAddress":
                    this.headerName = this.lbl.tax.headline_tax;
                    break;
                case "Favorite":
                    this.headerName = this.lbl.favorite.title;
                    break;
                case "Store":
                    this.headerName = this.lbl.store.title;
                    break;
                case "profile_edit":
                    this.headerName = "Edit Account";
                    break;
                case "changepass":
                    this.headerName = 'Change PIN Code';
                    break;
                case "resetpassword_email":
                    this.headerName = 'Change PIN Code';
                    break;
                case "MyCoupon":
                    this.headerName = this.lbl.mycoupon.title;
                    break;
                case "history":
                    this.headerName = this.lbl.history.title;
                    break;
                default:
                    this.headerName = "";
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .topbar-index {
        z-index: $zindex-fixed;
    }
    .accept-cookie {
        margin-top: 80px;
        @media (min-width: 1024px) {
            margin-top: 45px;
        }
    }
    .accept-cookie-page {
        padding-top: 140px;
        @media (min-width: 1024px) {
            padding-top: 110px;
        }
    }
</style>
